import { useMemo } from 'react'
import { FilterFieldsResponse } from 'shared/hooks/useFilterFields/useFilterFields'
import { GroupedFieldValues } from '../types'

export type UseFilterFormInitialDataParams = {
  fields: FilterFieldsResponse
}

export type UseFilterFormInitialDataResult = {
  initialGroupedFieldValues: GroupedFieldValues
  key: string
}

export const useFilterFormInitialData = ({
  fields
}: UseFilterFormInitialDataParams): UseFilterFormInitialDataResult => {
  const initialGroupedFieldValues = useMemo<GroupedFieldValues>(
    () => ({ 1: fields.initialFieldValues }),
    [fields.initialFieldValues]
  )

  const key = useMemo(() => JSON.stringify(fields), [fields])

  return {
    initialGroupedFieldValues,
    key
  }
}
